import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Text from '@zenbusiness/zui/Text';

import AccountFieldset from '#client/components/AccountFieldset';
import ConstructorCallout from '#client/components/ConstructorCallout';

function EditView({ sectionKey }) {
  const MESSAGE_IDS = {
    callout: 'shopping.page.checkoutSmartLlc.accountInfoCard.callout',
    tooltip: 'shopping.page.checkoutSmartLlc.accountInfoCard.tooltip'
  };

  return (
    <>
      <Text component="p">
        <FormattedMessage id={MESSAGE_IDS.tooltip} />
      </Text>

      <AccountFieldset
        fieldsConfig={{
          email: { show: true },
          password: { show: true }
        }}
        namePrefix={sectionKey}
      />
      <ConstructorCallout description={<FormattedMessage id={MESSAGE_IDS.callout} />} />
    </>
  );
}

EditView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default EditView;
